module.exports = __webpack_public_path__ + "static/media/select-date.9bae4ca5.svg";